import { requestJson } from './apiClient'
const BASE_PATH = '/api/flexihora/users'

const apiFlexihoraUserService = {
  listByEmpresaId(empresaId) {
    return requestJson({
      method: 'GET',
      path: BASE_PATH,
      query: { empresaId },
    })
  },
  setPassword(userId, payload) {
    const body = typeof payload === 'string' ? { password: payload } : payload
    return requestJson({
      method: 'PUT',
      path: `${BASE_PATH}/${userId}/password`,
      body,
    })
  },
}

export default apiFlexihoraUserService
